import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import clsx from "clsx";
import { TagItem } from "./tag.item";

import "./tags.dropdown.scss";

export const TagsDropdown = ({
  values,
  selected,
  onOptionSelected,
  className,
  disabled,
}) => {
  return (
    <Dropdown
      className={clsx("tags-dropdown", className)}
      selected={selected}
      onOptionSelected={onOptionSelected}
      disabled={disabled}
    >
      <DropdownButton clearEnabled>
        {selected ? <TagItem value={selected} /> : "Tag"}
      </DropdownButton>
      <DropdownItems>
        {values?.map((v) => (
          <DropdownItem value={v} key={v.id}>
            <TagItem value={v} />
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
